import { render, staticRenderFns } from "./SeatAreaOutline.vue?vue&type=template&id=6ff1798d&"
import script from "./SeatAreaOutline.vue?vue&type=script&lang=js&"
export * from "./SeatAreaOutline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports